import React from 'react';
import { useNavigate } from 'react-router-dom';
import ProLayout from '../layout/ProLayout';
import SmsModal from '../modals/SmsModal';

const SmsPage = () => {
  const navigate = useNavigate();

  return (
    <ProLayout title="SMS">
      <div className="modal-as-page h-full">
        <SmsModal
          isOpen={true}
          onClose={() => navigate('/optician-dashboard')}
        />
      </div>
    </ProLayout>
  );
};

export default SmsPage;
